// Adjust swatch hover images to match rendered container width
// Works alongside collection-script.js by updating image URLs when swatch images are inserted
(function () {
  function computeWidth(container) {
    if (!container) return 400;
    var w = Math.round(container.clientWidth);
    return w && w > 0 ? w : 400;
  }

  function getAdaptiveSizes(src) {
    if (src) {
      const imageExtensions = [".jpg", ".jpeg", ".png", ".webp"];
      const defaulySizes = ["_small", "_medium", "_large"];
      const currentExtension = imageExtensions.find((ext) => src.includes(ext));
      const sizeAdjustments = 0;

      if (!currentExtension) return src;

      const sizes = [200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2048, 2400];
      let cleanSrc = src;
      cleanSrc = cleanSrc.replace(/&width=\d+/g, "");
      defaulySizes.forEach((a) => (cleanSrc = cleanSrc.replace(a, "")));
      const srcset = sizes.reduce((acc, value) => {
        const separator = cleanSrc.indexOf("?") === -1 ? "?" : "&";
        const string =
          cleanSrc + `${separator}width=${value + sizeAdjustments} ${value}w, `;
        return acc + string;
      }, "");
      return srcset;
    }
    return "";
  }

  function getAdaptiveSrc(src, size) {
    if (!src) return;
    const imageExtensions = [".jpg", ".jpeg", ".png", ".webp"];
    const defaulySizes = ["_small", "_medium", "_large"];
    const currentExtension = imageExtensions.find((ext) => src.includes(ext));

    if (!currentExtension) return src;

    const srcParts = src.split(currentExtension);
    let cleanSrc = srcParts[0];
    defaulySizes.forEach((a) => (cleanSrc = cleanSrc.replace(a, "")));
    srcParts[0] = `${cleanSrc}_${size}x`;
    const adaptiveSrc = srcParts.join(currentExtension);

    return adaptiveSrc;
  }

  function speedCDNUrl(url) {
    if (!window.SPEED_CDN) return url;
    let newUrl = url;
    newUrl = url.replace("//cdn.shopify.com/", window.SPEED_CDN);
    newUrl = newUrl.replace("https:", "");
    return newUrl;
  }

  function setWidthParam(url, w) {
    try {
      // Replace existing width=NNN or append if missing
      if (/([?&])width=\d+/.test(url)) {
        return url.replace(/([?&])width=\d+/, "$1width=" + w);
      }
      return url + (url.indexOf("?") === -1 ? "?width=" + w : "&width=" + w);
    } catch (e) {
      return url;
    }
  }

  function adjustNode(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (!img.classList || !img.classList.contains("swatch")) return;
    var container = img.closest(".collection__item-bg-img-color-swatches");
    if (!container) return;
    var w = Math.round(computeWidth(container));
    var src = img.getAttribute("src") || "";
    if (!src) return;
    var cdnSrc = speedCDNUrl(src);
    var newSrc = setWidthParam(cdnSrc, Math.max(w * 2, 800));
    if (newSrc !== src) {
      //console.log(getAdaptiveSizes(cdnSrc), "newSRC", window.SPEED_CDN);
      img.src = newSrc;
      img.sizes = `${w}px`;
      img.srcset = getAdaptiveSizes(cdnSrc);
    }
  }

  function scanExisting() {
    document
      .querySelectorAll(".collection__item-bg-img-color-swatches img.swatch")
      .forEach(adjustNode);
  }

  function init() {
    scanExisting();
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList") {
          m.addedNodes &&
            m.addedNodes.forEach(function (node) {
              if (node instanceof Element) {
                if (
                  node.matches &&
                  node.matches(
                    ".collection__item-bg-img-color-swatches img.swatch"
                  )
                ) {
                  adjustNode(node);
                } else {
                  node.querySelectorAll &&
                    node
                      .querySelectorAll(
                        ".collection__item-bg-img-color-swatches img.swatch"
                      )
                      .forEach(adjustNode);
                }
              }
            });
        }
      });
    });
    obs.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });
    window.addEventListener("resize", function () {
      // On resize, re-adjust current swatch images to new width
      scanExisting();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
